module.exports = __webpack_public_path__ + "r-v3/img/ico_toast_info.2eec0689.svg";